import * as React from 'react';
import { WizardTabPane, TabType } from './WizardTabPane';
import { WizardProgressItem } from '../wizardProgressItem/wizardProgressItem';

interface WizardTabsComponentProps {
	//children?: React.ReactElement<TabPane>[];
	children?: any;
	selectedTab?: TabType;
	animate?: boolean;
	onSelect?: any;
	onClose?: any;
	onBack?: any;
	completedTabs: Array<TabType>;
	vinCheck: boolean;
}

interface WizardTabsComponentState {
	selectedTab: TabType;
	animate?: boolean;
}

export class WizardTabsComponent extends React.Component<WizardTabsComponentProps, WizardTabsComponentState> {
	constructor(props: WizardTabsComponentProps) {
		super(props);

		this.state = {
			selectedTab: props.selectedTab,
			animate: props.animate,
		};

		this.selectTab = this.selectTab.bind(this);
	}

	shouldComponentUpdate(nextProps: WizardTabsComponentProps, nextState: WizardTabsComponentState) {
		if (this.props.selectedTab !== nextProps.selectedTab) //props were changed outside of component
		{
			this.selectTab(nextProps.selectedTab);
		}

		return true;
	}

	private selectTab(selectedTab: TabType) {
		this.setState({
			...this.state,
			selectedTab,
		});
	}

	private getChildren() {
		let navigationItems: any[] = [];
		let tabPaneItems: any[] = [];

		React.Children.forEach(this.props.children, (child: React.ReactElement<any>, index) => {
			if (child) {
				const { name, title } = child.props;
				const selected = (name === this.state.selectedTab);
				const completed = this.props.completedTabs.some(item => item == name);

				navigationItems = [
					...navigationItems,
					<WizardProgressItem
						onClick={
							() => {
								//this.selectTab(name);
								//this.props.onSelect instanceof Function && this.props.onSelect(name);
							}
						}
						key={index} name={name} title={title} selected={selected} completed={completed} />
				];

				tabPaneItems = [
					...tabPaneItems,
					<WizardTabPane key={index} animate={this.props.animate} name={name} title={title} selected={selected}>
						{child.props.children}
					</WizardTabPane>
				];
			}
		});

		return [navigationItems, tabPaneItems];
	}

	render() {
		const [navigationItems, tabPaneItems] = this.getChildren();
		let showBackButton = this.props.selectedTab != TabType.Vin && (this.props.selectedTab != TabType.Model || this.props.vinCheck);

		return (
			<div className="wizard-tabs">
				<div className="wizard-header">
					<div className="wizard-confirm">
						{
							showBackButton &&
							<div className="confirm-image" onClick={() => this.onBack()}></div>
						}
					</div>

					<div className="wizard-progress" role="tablist">{navigationItems}</div>

					<div className="wizard-close">
						<div className="close-image" onClick={() => this.onClose()}></div>
					</div>
				</div>

				<div className="tab-content">
					{tabPaneItems}
				</div>
			</div>
		);
	}

	private onBack() {
		if (this.props.onBack) {
			this.props.onBack();
		}
	}

	private onClose() {
		if (this.props.onClose) {
			this.props.onClose();
		}
	}
}
